<template>
  <div v-if="hasAccess">
    <div class="py-4 container-fluid">
      <ToastPrime position="bottom-left" />
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 450px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex justify-content-between align-items-center">
                  <a class="d-flex align-items-center me-3" style="cursor: pointer" @click.prevent="$router.go(-1)">
                    <i class="pi pi-chevron-left text-dark mb-0" style="font-size: 1rem"></i>
                  </a>
                  <h5 class="mb-0">SAP Sync Params</h5>
                </div>
                <div class="d-flex align-items-center">
                  <button v-if="hasCreatePermission" type="button" class="mx-1 mb-0 btn btn-sm btn-primary" @click="openAddModal">Add</button>
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div style="height: 350px; overflow-y: auto">
              <DataTable
v-model:selection="table.selectedSyncParam" :value="table.data" :selection-mode="hasMappingViewPermission ? 'single' : undefined"
                :meta-key-selection="table.metaKey" scrollable scroll-height="flex" table-style="min-width: 100rem"
                data-key="id" @row-select="getValFromCertRow">
                <Column header="Code" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad" />
                    <span v-else>{{ row.data.code }}</span>
                  </template>
                </Column>
                <Column header="SAP Sync" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad" />
                    <span v-else>{{ row.data.sap_sync_data?.sync_name }}</span>
                  </template>
                </Column>
                <Column header="Param Type" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad" />
                    <span v-else>{{ row.data.param_type }}</span>
                  </template>
                </Column>
                <Column header="Source" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad" />
                    <span v-else>{{ row.data.source }}</span>
                  </template>
                </Column>
                <Column header="SAP Ref" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad" />
                    <span v-else>{{ row.data.sap_ref }}</span>
                  </template>
                </Column>
                <Column header="SAP Key" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad" />
                    <span v-else>{{ row.data.sap_key }}</span>
                  </template>
                </Column>
                <Column field="actions" header="Actions" header-class="bg-light text-dark" sortable>
                  <template v-if="table.onLoad" #body>
                    <Skeleton></Skeleton>
                  </template>
                  <template v-else #body="row">
                    <div v-if="table.data.length > 0 && row.data.code && !table.onLoad">
                      <ButtonPrime
v-if="hasUpdatePermission" v-tooltip.bottom="'Edit'" icon="pi pi-pencil" outlined
                        rounded size="small" @click="openEditModal(row.data)" />
                      <ButtonPrime
v-if="hasDeletePermission" v-tooltip.bottom="'Delete'" icon="pi pi-trash" outlined
                        rounded severity="danger" size="small" style="margin-left: 5px;"
                        @click="deleteSync(row.data.id)" />
                    </div>
                    <div v-else class="m-4"><span /></div>
                  </template>
                </Column>
                <template #empty>
                  <div class="text-center py-4">
                    <img src="/no_data.png" alt="No Data" style="width: 100px; height: 100px; opacity: 0.5;" />
                    <p class="text-muted mt-2">No items found</p>
                  </div>
                </template>
              </DataTable>
            </div>
            <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
              <BasePagination
v-model="table.page.current_page" :page-count="table.page.total_page" size="sm"
                @click="changePage()" />
              <p>
                {{ (table.page.current_page - 1) * table.page.per_page + table.data.length }}
                of {{ table.total }}
              </p>
            </div>
          </div>
        </div>

        <div class="my-4"></div>
        <!-- Tabel kedua -->
        <div class="col-12">
          <div class="card" style="height: 350px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-4">
                  <h5>SAP Sync Params Mapping</h5>
                </div>
                <div class="col-2 ms-auto">
                  <div class="my-auto float-end">
                    <button
v-if="hasMappingCreatePermission" type="button" class="mx-1 mb-0 btn btn-sm btn-primary" :disabled="!table.selectedSyncParam"
                      @click="openAddModalMapping">Add</button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div style="height: 350px; overflow-y: auto">
              <DataTable :value="tableMapping.data" scrollable scroll-height="flex" table-style="min-width: 70rem">
                <Column header="Sap Sync Param" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad || tableMapping.onLoad" />
                    <span v-else>{{ row.data.sap_sync_param }}</span>
                  </template>
                </Column>
                <Column header="Data Type" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad || tableMapping.onLoad" />
                    <span v-else>{{ row.data.data_type }}</span>
                  </template>
                </Column>
                <Column header="Source Column" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad || tableMapping.onLoad" />
                    <span v-else>{{ row.data.source_column }}</span>
                  </template>
                </Column>
                <Column header="SAP Column" header-class="bg-light">
                  <template #body="row">
                    <Skeleton v-if="table.onLoad || tableMapping.onLoad" />
                    <span v-else>{{ row.data.sap_column }}</span>
                  </template>
                </Column>
                <Column
header="" header-class="bg-light" :style="{ width: '100px' }"
                  :body-style="{ width: '100px', padding: '0' }">
                  <template #body="row">
                    <div v-if="tableMapping.data.length > 0 && row.data.sap_sync_param && !tableMapping.onLoad">
                      <ButtonPrime
v-if="hasMappingUpdatePermission" v-tooltip.top="'Edit'" icon="pi pi-pencil" outlined rounded
                        size="small" @click="openEditModalMapping(row.data)" />
                      <ButtonPrime
v-if="hasMappingDeletePermission" v-tooltip.top="'Delete'" icon="pi pi-trash" outlined rounded severity="danger"
                        size="small" style="margin-left: 5px;" @click="deleteMapping(row.data.id)" />
                    </div>
                    <div v-else class="m-4"><span /></div>
                  </template>
                </Column>
                <template #empty>
                  <div class="text-center py-4">
                    <img src="/no_data.png" alt="No Data" style="width: 100px; height: 100px; opacity: 0.5;" />
                    <p class="text-muted mt-2">No items found</p>
                  </div>
                </template>
              </DataTable>
            </div>
            <div class="card-footer pb-0 d-flex justify-content-between align-items-center">
              <BasePagination
v-model="tableMapping.page.current_page" :page-count="tableMapping.page.total_page"
                size="sm" @click="changePage()" />
              <p>
                {{ (tableMapping.page.current_page - 1) * tableMapping.page.per_page + tableMapping.data.length }}
                of {{ tableMapping.total }}
              </p>
            </div>
          </div>
        </div>

        <!-- add&edit sap sycn Params -->
        <DialogPrime v-model:visible="modal.visible" :header="modal.title" style="width: 45rem; margin: 10px;">
          <div class="mb-2 row">
            <div class="col-sm-12">
              <label for="code" class="font-semibold">Code <span class="text-danger">*</span></label>
              <InputText
id="code" v-model="modal.data.code" placeholder="Eg: ZA01_GET_EQUI_LIST"
                :class="`${(modal.errorMessage['code'] && modal.data.code == '') ? 'border-danger' : ''}`"
                fluid @input="toUpperCaseVal($event, 'code')" />
              <small v-if="modal.errorMessage['code'] && modal.data.code == ''" class="text-danger">{{
                modal.errorMessage['code'] }}</small>
            </div>
          </div>

          <div class="mb-2 row">
            <div class="col-md-6 col-sm-12">
              <label for="param_type" class="font-semibold">Param Type <span class="text-danger">*</span></label>
              <SelectPrime
id="param_type" v-model="modal.data.param_type" :options="optParamType"
                option-label="label" option-value="code" placeholder="Please choose param type"
                :invalid="modal.errorMessage['param_type'] && modal.data.param_type === ''" class="w-full md:w-56"
                fluid />
              <small v-if="modal.errorMessage['param_type'] && modal.data.param_type == ''" class="text-danger">{{
                modal.errorMessage['param_type'] }}</small>
            </div>
            <div class="col-md-6 col-sm-12">
              <label for="sap_ref" class="font-semibold">SAP Ref </label>
              <InputText id="sap_ref" v-model="modal.data.sap_ref" placeholder="Eg: T_DATA" fluid />
            </div>
          </div>

          <div class="mb-5 row">
            <div class="col-md-6 col-sm-12">
              <label for="source" class="font-semibold">Source </label>
              <PrimeTextarea
id="source" v-model="modal.data.source" rows="5" cols="30" placeholder="Eg: script"
                fluid />
            </div>
            <div class="col-md-6 col-sm-12">
              <label for="sap_key" class="font-semibold">SAP Key </label>
              <PrimeTextarea
id="sap_key" v-model="modal.data.sap_key" rows="5" cols="30" style="resize: none;"
                placeholder="[ {'MAABC' : '', 'TMABC' : ''} ]" fluid />
            </div>
          </div>

          <template #footer>
            <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
              <ButtonPrime
type="button" label="Cancel" severity="danger" class="px-4 border-0" raised size="small"
                :disabled="modal.onLoading" @click="modal.visible = false" />
              <ButtonPrime
type="button" severity="contrast" raised size="small" label="Save" class="px-4"
                :disabled="modal.onLoading" @click="save()">
                <template v-if="modal.onLoading" #icon>
                  <i class="fas fa-spinner fa-spin me-2"></i>
                </template>
              </ButtonPrime>
            </div>
          </template>
        </DialogPrime>

        <!-- add&edit sap sycn Params Mapping-->
        <DialogPrime
v-model:visible="modalMapping.visible" :header="modalMapping.title"
          style="width: 30rem; margin: 10px;">
          <div class="mb-2">
            <label for="data_type" class="font-semibold">Data Type <span class="text-danger">*</span></label>
            <InputText
id="data_type" v-model="modalMapping.data.data_type" placeholder="Eg: string"
              :class="`${(modalMapping.errorMessage['data_type'] && modalMapping.data.data_type == '') ? 'border-danger' : ''}`"
              fluid />
            <small
v-if="modalMapping.errorMessage['data_type'] && modalMapping.data.data_type == ''"
              class="text-danger">{{
                modalMapping.errorMessage['data_type'] }}</small>
          </div>
          <div class="mb-2">
            <label for="source_column" class="font-semibold">Source Column <span class="text-danger">*</span></label>
            <PrimeTextarea
id="source_column" v-model="modalMapping.data.source_column" rows="4" cols="30"
              placeholder="Eg: abc_indicator_code"
              :class="`${(modalMapping.errorMessage['source_column'] && modalMapping.data.source_column == '') ? 'border-danger' : ''}`"
              fluid />
            <small
v-if="modalMapping.errorMessage['source_column'] && modalMapping.data.source_column == ''"
              class="text-danger">{{ modalMapping.errorMessage['source_column'] }}</small>
          </div>
          <div class="mb-5">
            <label for="sap_column" class="font-semibold">SAP Column <span class="text-danger">*</span></label>
            <InputText
id="sap_column" v-model="modalMapping.data.sap_column" placeholder="Eg: ${MAABC}"
              :class="`${(modalMapping.errorMessage['sap_column'] && modalMapping.data.sap_column == '') ? 'border-danger' : ''}`"
              fluid />
            <small
v-if="modalMapping.errorMessage['sap_column'] && modalMapping.data.sap_column == ''"
              class="text-danger">{{
                modalMapping.errorMessage['sap_column'] }}</small>
          </div>

          <template #footer>
            <div class="d-flex justify-content-end gap-2 pt-3 border-top w-100 mt-2 px-1">
              <ButtonPrime
type="button" label="Cancel" severity="danger" class="px-4 border-0" raised size="small"
                :disabled="modalMapping.onLoading" @click="modalMapping.visible = false" />
              <ButtonPrime
type="button" severity="contrast" raised size="small" label="Save" class="px-4"
                :disabled="modalMapping.onLoading || anyEmptyVal" @click="saveMapping()">
                <template v-if="modalMapping.onLoading" #icon>
                  <i class="fas fa-spinner fa-spin me-2"></i>
                </template>
              </ButtonPrime>
            </div>
          </template>
        </DialogPrime>

      </div>
    </div>
  </div>
  <NoAccess v-else />
</template>

<script>
import { mapState } from "vuex";
import NoAccess from "@/components/NoAccess.vue";
import sapSyncParamsService from "@/services/sap/sapSyncParamsService";
import api from "@/helpers/api";

export default {
  components: {
    NoAccess,
  },
  data() {
    return {
      sapSyncCode: this.$route.params.sapSync || "",
      tableMapping: {
        onLoad: false,
        total: 0,
        data: [{}],
        page: {
          current_page: 1,
          total_page: 1,
        },
        limit: 100,
      },
      table: {
        onLoad: true,
        total: 0,
        data: [{}],
        page: {
          current_page: 1,
          total_page: 1,
        },
        limit: 100,
        selectedSyncParam: null,
        metaKey: null
      },
      modal: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
      modalMapping: {
        visible: false,
        action: "",
        title: "",
        data: {},
        errorMessage: {},
        onLoading: false,
      },
      optParamType: [{ label: 'Input', code: 'input' }, { label: 'Output', code: 'output' }],
    };
  },
  computed: {
    ...mapState({
      authUserPermissions: (state) => state.auth.userHasPermissions || [],
    }),
    hasAccess() {
      return this.authUserPermissions.includes('sap-sync-param-view');
    },
    hasCreatePermission() {
      return this.authUserPermissions.includes('sap-sync-param-create');
    },
    hasUpdatePermission() {
      return this.authUserPermissions.includes('sap-sync-param-update');
    },
    hasDeletePermission() {
      return this.authUserPermissions.includes('sap-sync-param-delete');
    },
    hasMappingViewPermission() {
      return this.authUserPermissions.includes('sap-sync-param-mapping-view');
    },
    hasMappingCreatePermission() {
      return this.authUserPermissions.includes('sap-sync-param-mapping-create');
    },
    hasMappingUpdatePermission() {
      return this.authUserPermissions.includes('sap-sync-param-mapping-update');
    },
    hasMappingDeletePermission() {
      return this.authUserPermissions.includes('sap-sync-param-mapping-delete');
    },
    anyEmptyVal() {
      // return (!this.table.selectedSyncParam.code || !this.modalMapping.data.data_type || !this.modalMapping.data.source_column || !this.modalMapping.data.sap_column);
      return (!this.modalMapping.data.sap_sync_param || !this.modalMapping.data.data_type || !this.modalMapping.data.source_column || !this.modalMapping.data.sap_column);
    }
  },
  mounted() {
    if (this.hasAccess) {
      this.get();
    }
  },
  methods: {
    async get() {
      if (!this.hasAccess) return;
      this.table.onLoad = true
      try {
        const response = await api(this, sapSyncParamsService.list({ limit: this.table.limit, page: this.table.page.current_page, sap_sync: this.sapSyncCode }), false);

        this.table.data = response.data.data;
        this.table.total = response.data.total;
        this.table.page = response.data;
        this.table.page.total_page = response.data.last_page;
      } catch (error) {
        this.table.data = [{}]
        this.table.total = 0
      } finally {
        this.table.onLoad = false;
      }
    },
    openEditModal(sync) {
      this.modal = {
        action: "edit params",
        visible: true,
        title: "Edit SAP Sync Params",
        data: { ...sync },
        errorMessage: {},
        onLoading: false,
      }
    },
    openAddModal() {
      this.modal = {
        action: "create params",
        visible: true,
        title: "Add SAP Sync Param",
        data: { id: "", code: "", sap_sync: this.sapSyncCode, param_type: "", sap_ref: "", source: "", sap_key: "" },
        errorMessage: {},
        onLoading: false,
      }
    },
    async save() {
      if (this.modal.action === "create params" && !this.hasCreatePermission) return;
      if (this.modal.action === "edit params" && !this.hasUpdatePermission) return;
      let isValid = true;
      const requiredField = [{ key: "code", message: "Code" }, { key: "sap_sync", message: "SAP Sync" }, { key: "param_type", message: "Param Type" }];
      requiredField.forEach((val) => {
        if (!this.modal.data[val.key]) {
          this.modal.errorMessage[val.key] = `${val.message} is required`;
          isValid = false;
        }
      })
      if (!isValid) return false;

      this.modal.onLoading = true;
      try {
        if (this.modal.action === "create params") {
          await api(this, sapSyncParamsService.create(this.modal.data));
        } else if (this.modal.action === "edit params") {
          await api(this, sapSyncParamsService.update(this.modal.data.id, this.modal.data));
        }

        this.modal.data = {};
        this.modal.visible = false;
        this.get();
      } catch (error) {
        this.handleErrorObjectNested(error)
      } finally {
        this.modal.onLoading = false;
      }
    },
    deleteSync(id) {
      if (!this.hasDeletePermission) return;
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          this.table.onLoad = true
          api(this, sapSyncParamsService.delete(id)).then(() => {
            this.get();
          }).catch(() => {  
            this.table.onLoad = false
          });
        }
      });
    },
    getValFromCertRow() {
      if (!this.hasMappingViewPermission) return;
      this.fetchSapSyncParamsMapping(this.table.selectedSyncParam.code);
    },
    async fetchSapSyncParamsMapping(code) {
      if (!this.hasMappingViewPermission) return;
      this.tableMapping.onLoad = true
      try {
        const response = await api(this, sapSyncParamsService.getSapSyncParamsMappingList(code, { limit: this.tableMapping.limit, page: this.tableMapping.page.current_page }), false);

        this.tableMapping.data = response.data.data
        this.tableMapping.total = response.data.total
        this.tableMapping.page = response.data
        this.tableMapping.page.total_page = response.data.last_page;
      } catch (error) {
        this.tableMapping.data = [{}]
        this.tableMapping.total = 0
      } finally {
        this.tableMapping.onLoad = false
      }
    },
    openAddModalMapping() {
      this.modalMapping = {
        visible: true,
        action: "create",
        title: "Add SAP Sync Params Mapping",
        data: { id: "", sap_sync_param: this.table.selectedSyncParam.code, data_type: "", source_column: "", sap_column: "" },
        errorMessage: {},
        onLoading: false,
      }
    },
    openEditModalMapping(mapping) {
      this.modalMapping = {
        visible: true,
        action: "edit",
        title: "Edit SAP Sync Params Mapping",
        data: { ...mapping },
        errorMessage: {},
        onLoading: false,
      }
    },
    deleteMapping(id) {
      if (!this.hasMappingDeletePermission) return;
      this.confirmDialog("You won't be able to revert this!", "delete it").then((result) => {
        if (result.isConfirmed) {
          this.tableMapping.onLoad = true
          api(this, sapSyncParamsService.deleteMapping(id)).then(() => {
            this.fetchSapSyncParamsMapping(this.table.selectedSyncParam.code);
          });
        }
      });
    },
    async saveMapping() {
      if (this.modalMapping.action === "create" && !this.hasMappingCreatePermission) return;
      if (this.modalMapping.action === "edit" && !this.hasMappingUpdatePermission) return;
      this.modalMapping.onLoading = true;
      try {
        if (this.modalMapping.action === "create") {
          await api(this, sapSyncParamsService.createMapping(this.modalMapping.data));
        } else if (this.modalMapping.action === "edit") {
          await api(this, sapSyncParamsService.updateMapping(this.modalMapping.data.id, this.modalMapping.data));
        }

        this.modalMapping.data = {};
        this.modalMapping.visible = false;
        this.fetchSapSyncParamsMapping(this.table.selectedSyncParam.code);
      } catch (error) {
        this.handleErrorObjectNested(error)
      } finally {
        this.modalMapping.onLoading = false;
      }
    },
    handleErrorObjectNested(error) {
      if (error.response?.data?.code == 400 || error.response?.status == 422 || error.response?.status == 500) {
        const errorData = error.response?.data?.data;

        if (typeof errorData === 'object' && errorData !== null) {
          for (const key in errorData) {
            if (Object.prototype.hasOwnProperty.call(errorData, key)) {
              const match = key.match(/^items\.(\d+)\.(.+)$/);
              if (match) {
                error.response.data.data[key].forEach(message => {
                  this.$toastNotifPrime('error', error.response.data.message, `${message} in row ${parseInt(match[1]) + 1}`)
                })
              } else {
                this.$toastNotifPrime('error', error.response.data.message, errorData[key]);
                // errorData[key].forEach(message => {
                //   this.$toastNotifPrime('error', error.response.data.message, message);
                // });
              }
            }
          }
        }
      }
    },
    changePage() {
      this.table.onLoad = true;
      setTimeout(() => {
        this.get();
      }, 100);
    },
    toUpperCaseVal(event, key) {
      const input = event.target;
      const start = input.selectionStart;
      const end = input.selectionEnd;

      const upper = input.value.toUpperCase();
      this.modal.data[key] = upper;

      this.$nextTick(() => {
        input.setSelectionRange(start, end);
      });
    },
  },
};
</script>

<style scoped>
.value-table-wrapped {
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
